module.exports = __webpack_public_path__ + "static/media/  (37).8b2009b0.jpg";